import { HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import moment from "moment";
import { BehaviorSubject, Observable } from "rxjs";
import { AccountDetail } from "src/app/pages/account/models/account-detail";
import { AllocationLog } from "src/app/pages/allocation/models/allocation-log";
import { AllocationLogSearch } from "src/app/pages/allocation/models/allocation-log-search";
import { Allocation } from "src/app/pages/allocation/models/today-allocation";
import { TodayOrders } from "src/app/pages/allocation/models/today-orders";
import { Trade } from "src/app/pages/allocation/models/trade";
import { TradeSummary } from "src/app/pages/allocation/models/trade-summary";
import { APP_CONFIG } from "../app.config";
import { AppConfig } from "../models/app.config";
import { ApiService } from "./api.service";


@Injectable({
    providedIn: "root",
})
export class AccountService {
    private readonly accountEndpointUrl: string = "Account/";
    config: AppConfig;

    constructor(private apiService: ApiService, @Inject(APP_CONFIG) config: AppConfig,) {
        this.config = config;
    }
    public searchLogExecutedSubject = new BehaviorSubject<AllocationLogSearch>({ riaId: 0, fromDate: "", toDate: "" });
    public searchLogExecuted$ = this.searchLogExecutedSubject.asObservable();

    public getAccounts(riaId: number): Observable<AccountDetail> {
        const params = new HttpParams()
            .set("riaID", riaId);
        return this.apiService.get<AccountDetail>(`${this.accountEndpointUrl}GetDVPAccountsByRiaId`, params);
    }

    public getAllTrade(riaId: number): Observable<Trade[]> {
        const params = new HttpParams()
            .set("riaID", riaId);
        return this.apiService.get<Trade[]>(`${this.accountEndpointUrl}GetAllTrade`, params);
    }

    public getAllTradeSummary(riaId: number): Observable<TradeSummary[]> {
        const params = new HttpParams()
            .set("riaID", riaId);
        return this.apiService.get<TradeSummary[]>(`${this.accountEndpointUrl}GetTradeSummary`, params);
    }


    public getAllOrders(riaId: number, accountPk?: number | null): Observable<TodayOrders[]> {
        let params = new HttpParams().set("riaID", riaId);
        if (accountPk != null) { // Check if accountPk is not null and not undefined
            params = params.set("accountPk", accountPk.toString());
        }
        return this.apiService.get<TodayOrders[]>(`${this.accountEndpointUrl}GetAllOrdersAndDVPOrders`, params);
    }

    public getHistorySummary(riaId: number): Observable<Allocation[]> {
        let params = new HttpParams().set("riaID", riaId);
        return this.apiService.get<Allocation[]>(`${this.accountEndpointUrl}GetHistorySummary`, params);
    }

    public getCombinedOrder(element): Observable<Trade[]> {
        return this.apiService.post<Trade[]>(`${this.accountEndpointUrl}GetCombinedOrder`, JSON.stringify(element));
    }

    public GetAllocationLog(riaId: number, fromDate: string, toDate: string): Observable<AllocationLog[]> {

        const fromDateFormat = moment(fromDate).format(this.config.dateFormat);
        const toDateFormat = moment(toDate).format(this.config.dateFormat);

        let params = new HttpParams()
            .set("riaID", riaId.toString()) // Ensure the ID is passed as a string
            .set("fromDate", fromDateFormat)
            .set("toDate", toDateFormat);

        return this.apiService.get<AllocationLog[]>(`${this.accountEndpointUrl}GetAllocationLog`, params);
    }
}
